module.exports = __webpack_public_path__ + "img/fist-demeter.e774c89c.jpg";